import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { imgFallback, imgSrc } from "@/lib/api";
import { tl } from "@/lib/format";

export const ProductCard = ({ p, idx = 0, compact = false }) => {
  const isBulk = p.type === "dokme";
  return (
    <Link
      to={`/urun/${p.slug}`}
      data-testid={`product-card-${p.slug}`}
      className={`group fade-up flex flex-col rounded-2xl border border-border/70 bg-card p-3 shadow-[0_8px_30px_rgba(42,29,22,0.06)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgba(42,29,22,0.14)] ${compact ? "w-[220px] flex-none snap-start sm:w-[240px]" : ""}`}
      style={{ animationDelay: `${Math.min(idx, 8) * 60}ms` }}
    >
      <div className="relative aspect-square overflow-hidden rounded-xl bg-white">
        <img src={imgSrc(p.images?.[0], 480)} alt={p.name} loading="lazy" decoding="async" width="480" height="480" onError={imgFallback} className="product-img h-full w-full object-contain p-1 transition-transform duration-500 group-hover:scale-105" />
        {p.sale_percent > 0 && <span className="absolute left-2 top-2 rounded-full bg-accent px-2.5 py-1 text-[11px] font-bold text-white">%{p.sale_percent} İndirim</span>}
        {!p.in_stock && <span className="absolute inset-x-2 bottom-2 rounded-full bg-[hsl(var(--espresso))] py-1.5 text-center text-xs font-semibold text-[hsl(var(--cream))]">Tükendi</span>}
      </div>
      <div className="flex flex-1 flex-col gap-1 px-1 pt-3">
        <h3 className="line-clamp-2 min-h-[2.6em] font-sans text-[15px] font-semibold leading-snug">{p.name}</h3>
        <div className="mt-auto flex items-end justify-between gap-2 pt-2">
          <div>
            <div className="flex items-baseline gap-1.5">
              <span data-testid={`product-card-${p.slug}-price`} className="text-lg font-bold tabular-nums">{tl(p.sale_price)}{isBulk && <span className="text-xs font-medium text-muted-foreground"> / kg</span>}</span>
              {p.sale_percent > 0 && <span className="text-xs text-muted-foreground line-through">{tl(p.price)}</span>}
            </div>
            <p className="text-xs text-muted-foreground">{isBulk ? `100 g'den başlayan: ${tl(p.variants?.[0]?.price)}` : p.unit_label || "adet"}</p>
          </div>
          <span className="flex h-9 w-9 flex-none items-center justify-center rounded-full border-2 border-[hsl(var(--espresso))] transition-colors group-hover:bg-primary group-hover:border-primary" aria-hidden="true"><Plus className="h-4 w-4" /></span>
        </div>
      </div>
    </Link>
  );
};
